/**
 * @file 获取指定页面的微信
 * @author
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { WX_ENV } from '@umu/umu-types';

export interface IGetWxJsConfigInput {
    url: string;
    is_wx?: string; // 选填，微信类型：0.非微信环境；1.微信；2.企业微信
}

export interface IGetWxJsConfigOutput {
    appid: string;
    noncestr: string;
    signature: string;
    timestamp: number;
    url: string;
}

export const getWxJsConfig = (data: IGetWxJsConfigInput): Promise<IResponse<IGetWxJsConfigOutput>> => {
    if (data.is_wx === WX_ENV.WX_WORK) {
        return fetchData(Api.GET_WX_JS_CONFIG, data);
    } else {
        return fetchData(Api.GET_WX_JS_CONFIG, data);
    }
};
